import { requestJSON } from '../../../NonReact/common/API/REST/RESTClient'
import { JSONResponse } from '../../../NonReact/common/Types/Types'
import { AUTH_TOKEN_URL, REFRESH_TOKEN_URL } from '../../../NonReact/constants/ApiConstants'
import { RESTMethods } from '../../../NonReact/constants/REST'
import { TokenResponse, RefreshTokenRequest } from '../../../NonReact/Types/Types'

const TIMEOUT_IN_MS: number = 4000

export const fetchAccessToken = (): Promise<TokenResponse | null> =>
    requestJSON<TokenResponse>(AUTH_TOKEN_URL, {
        method: RESTMethods.POST,
        timeout: TIMEOUT_IN_MS
    }).then((response: JSONResponse<TokenResponse>) => response ?? null)

export const refreshAccessToken = (refreshToken: string): Promise<TokenResponse | null> =>
    requestJSON<TokenResponse, RefreshTokenRequest>(REFRESH_TOKEN_URL, {
        method: RESTMethods.POST,
        timeout: TIMEOUT_IN_MS,
        body: { RefreshToken: refreshToken }
    }).then((response: JSONResponse<TokenResponse>) => response ?? null)
